/*
  ED:EN — require an intentional size selection before purchase.
  Applies only to product forms that contain a Shopify option named "Size".
*/
(() => {
  const readyForms = new WeakSet();

  const addStyles = () => {
    if (document.getElementById('eden-require-size-styles')) return;

    const style = document.createElement('style');
    style.id = 'eden-require-size-styles';
    style.textContent = `
      .eden-size-required .add-to-cart-btn {
        position: relative;
        pointer-events: none;
        opacity: .55;
      }

      .eden-size-required .add-to-cart-btn > * {
        visibility: hidden !important;
      }

      .eden-size-required .add-to-cart-btn::after {
        position: absolute;
        inset: 0;
        display: grid;
        place-items: center;
        visibility: visible;
        content: "Select a size";
      }

      .eden-size-required .dynamic-payment-buttons {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
  };

  const getForm = (input) => {
    const formId = input.getAttribute('form');
    return (formId && document.getElementById(formId)) || input.closest('form');
  };

  const prepareForm = (form, inputs) => {
    if (!form || readyForms.has(form)) return;
    readyForms.add(form);

    const fieldset = inputs[0].closest('fieldset');
    const addButton = form.querySelector('.add-to-cart-btn');

    form.classList.add('eden-size-required');
    if (addButton) addButton.disabled = true;

    inputs.forEach((input) => {
      input.checked = false;
      input.removeAttribute('checked');
      input.setAttribute('aria-checked', 'false');
    });

    const unlock = (event) => {
      if (!inputs.includes(event.target)) return;

      form.classList.remove('eden-size-required');
      if (addButton) addButton.disabled = false;

      inputs.forEach((input) => {
        input.setAttribute('aria-checked', input.checked ? 'true' : 'false');
      });
    };

    inputs.forEach((input) => input.addEventListener('change', unlock));

    form.addEventListener('submit', (event) => {
      if (!form.classList.contains('eden-size-required')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      fieldset?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, true);
  };

  const initialize = () => {
    addStyles();

    const groups = new Map();
    document
      .querySelectorAll('input[type="radio"][name="options[Size]"]')
      .forEach((input) => {
        const form = getForm(input);
        if (!form) return;
        if (!groups.has(form)) groups.set(form, []);
        groups.get(form).push(input);
      });

    groups.forEach((inputs, form) => prepareForm(form, inputs));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  window.setTimeout(initialize, 250);
  document.addEventListener('shopify:section:load', initialize);
})();
